import { Message } from 'element-ui'

const rawMessage = Message

function wrapMessage(options) {
  if (typeof options === 'string') {
    options = { message: options }
  }
  return rawMessage({
    duration: 3000,
    customClass: 'so-compact-message',
    ...options
  })
}

;['success', 'warning', 'info', 'error'].forEach(type => {
  wrapMessage[type] = (msg) => {
    if (typeof msg === 'object' && msg !== null) {
      return wrapMessage({ type, ...msg })
    }
    return wrapMessage({ message: msg, type })
  }
})

wrapMessage.close = rawMessage.close
wrapMessage.closeAll = rawMessage.closeAll

export default wrapMessage
